import React, {useState, useEffect, useRef} from 'react';
import {withRouter, Link} from 'react-router-dom';
import {connect} from 'react-redux';
import ReCAPTCHA from "react-google-recaptcha";
import {resetPassword, clearResetPassword} from '../../../state/actions/authActions';
import { ENABLE_CAPTCHA } from '../../../config';
import {
  Typography,
  Card,
  CardActions,
  CardContent,
  TextField,
  Button,
  CircularProgress,
} from '@material-ui/core';

function ResetPassword({
  history,
  isLoggedIn,
  loginInProgress,
  resetPasswordState,
  resetPassword,
  clearResetPassword,
}) {
  const [username, setUsername] = useState('');
  const [recaptchaResponse, setRecaptchaResponse] = useState('');
  const recaptchaRef = useRef(null);

  useEffect(() => {
    if (isLoggedIn) {
      history.push('/explore');
    }
  })

  useEffect(() => {
    return clearResetPassword;
  }, [clearResetPassword]);

  useEffect(() => {
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
    }
  }, [resetPasswordState]);

  const handleSendEmail = () => {
    resetPassword(username, recaptchaResponse);
  }

  let errorMessage = null;
  if (resetPasswordState) {
    if (resetPasswordState.status === 'user_not_found') {
      errorMessage = "User not found."
    }
    else if (resetPasswordState.status === 'invalid_recaptcha') {
      errorMessage = "reCAPTCHA response is invalid."
    }
    else if (resetPasswordState.status !== 'ok') {
      errorMessage = "There was an unknown error on password reset."
    }
  }

  let resetForm = <Card style={{borderTop: '1px solid rgba(0,0,0,0.12)'}}>
    <form onKeyDown={event => (event.keyCode === 13) && handleSendEmail()} autoComplete="off">
    <CardContent>
      <h2 style={{fontWeight: '400', marginTop: 0}}>Reset Password</h2>
      {
        errorMessage &&
        <Typography id="errors" color="textSecondary" gutterBottom style={{backgroundColor: '#ffbdbd', padding: '4px 8px', borderRadius: '4px'}}>
          {errorMessage}
        </Typography>
      }
      <div>
        <Typography id="message">If you've forgotten your password, we can send you an email with a link that will let you pick a new password.</Typography>
      </div>
      <div>
        <TextField
          id='username'
          label='Username or email'
          fullWidth
          value={username}
          onChange={event => {setUsername(event.target.value)}}
          margin='normal'
          variant='outlined'
        />
      </div>
      <div>
        { typeof(ENABLE_CAPTCHA) !== 'undefined' && ENABLE_CAPTCHA &&
          <ReCAPTCHA
            id="captcha"
            sitekey='6LfaYIUeAAAAAILmLoRvqHd-8-7rGt0V7QwHZOkf'
            onChange={response => setRecaptchaResponse(response)}
            ref={recaptchaRef}
          />
        }
      </div>
    </CardContent>
    <CardActions>
      <div style={{padding: 8, position: 'relative'}}>
        <Button id="send" variant='contained' color='primary' disabled={loginInProgress} onClick={handleSendEmail} >Send Email</Button>
        { loginInProgress
          && <CircularProgress id="sending" size={24} style={{position: 'absolute', top: '50%', left: '50%', marginTop: -12, marginLeft: -12}}/>}
      </div>
      <Link id="login" to="/login">Login</Link>
    </CardActions>
    </form>
  </Card>

  let resetSuccess = <Card>
    <CardContent id="resetSent">
      <div style={{marginBottom: "1rem"}}>
        <h2 style={{fontWeight: '400', marginTop: 0}}>Reset Password</h2>
      </div>
      <Typography id="message">Please check your email and follow the link we sent you.</Typography>
    </CardContent>
  </Card>
  return (
    <div style={{maxWidth: 400, margin: '0 auto', marginTop: 64}}>
      {(resetPasswordState && resetPasswordState.status === 'ok') ? resetSuccess : resetForm}
    </div>
  );
}

const mapStateToProps = state => ({
  isLoggedIn: state.auth.uid,
  loginInProgress: state.auth.loginInProgress,
  resetPasswordState: state.auth.resetPasswordState,
});

const mapDispatchToProps = {
  resetPassword,
  clearResetPassword,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ResetPassword));
